import { render, staticRenderFns } from "./CandidatesPage.vue?vue&type=template&id=f94c6850"
import script from "./CandidatesPage.vue?vue&type=script&setup=true&lang=js"
export * from "./CandidatesPage.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/r1/a/_stemdoplatform/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f94c6850')) {
      api.createRecord('f94c6850', component.options)
    } else {
      api.reload('f94c6850', component.options)
    }
    module.hot.accept("./CandidatesPage.vue?vue&type=template&id=f94c6850", function () {
      api.rerender('f94c6850', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/main/webapp/app/pages/client/candidates/CandidatesPage.vue"
export default component.exports